<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container modal-container-80 w-75" @mousedown.stop="" @click="dontClose">
          <div class="modal-body m-0 p-5" style="margin: auto">
            <div class="col-12 px-0 px-md-2">
              <div class="">
                <b-row class="justify-content-start">
                  <b-col cols="6">
                    <form-write-group-label-input
                        v-model="form.CN"
                        :inputLabel="$t('common.security.common_name')"
                        :placeholderValue="$t('common.security.common_name')"
                        >
                    </form-write-group-label-input>
                  </b-col>

                  <b-col cols="6">
                    <form-write-group-label-input
                        v-model="form.C"
                        :inputLabel="$t('common.security.country')"
                        :placeholderValue="$t('common.security.country')"
                    >
                    </form-write-group-label-input>
                  </b-col>
                </b-row>

                <b-row class="mt-5">
                  <b-col cols="6">
                    <form-write-group-label-input
                        v-model="form.O"
                        :inputLabel="$t('common.security.organization')"
                        :placeholderValue="$t('common.security.organization')"
                    >
                    </form-write-group-label-input>
                  </b-col>

                  <b-col cols="6">
                    <form-write-group-label-input
                        v-model="form.L"
                        :inputLabel="$t('common.security.l')"
                        :placeholderValue="$t('common.security.l')">
                    </form-write-group-label-input>
                  </b-col>
                </b-row>

                <b-row class="mt-5">
                  <b-col cols="6">
                    <form-write-group-label-input
                        v-model="form.subjectAltName"
                        :inputLabel="$t('common.security.subject_alt_name')"
                        :placeholderValue="$t('common.security.subject_alt_name')">
                    </form-write-group-label-input>
                  </b-col>

<!--                  <b-col cols="6">-->
<!--                    <form-write-group-label-input-->
<!--                        v-model="form.mode"-->
<!--                        :inputLabel="$t('common.security.mode')"-->
<!--                        :placeholderValue="$t('common.security.mode')"-->
<!--                        disabled>-->
<!--                    </form-write-group-label-input>-->
<!--                  </b-col>-->
                </b-row>

<!--                <b-row class="mt-5">-->

<!--                  <b-col cols="6">-->
<!--                    <form-write-group-label-input-->
<!--                        v-model="form.CIB"-->
<!--                        :inputLabel="$t('common.security.CIB')"-->
<!--                        :placeholderValue="$t('common.security.CIB')"-->
<!--                    >-->
<!--                    </form-write-group-label-input>-->
<!--                  </b-col>-->
<!--                  <b-col cols="6">-->
<!--                    <form-write-group-label-input-->
<!--                        v-model="form.siren"-->
<!--                        :inputLabel="$t('common.security.siren')"-->
<!--                        :placeholderValue="$t('common.security.siren')">-->
<!--                    </form-write-group-label-input>-->
<!--                  </b-col>-->
<!--                </b-row>-->

              </div>
            </div>
          </div>

          <!-- Footer avec boutons d'action -->
          <div class="modal-footer m-0 d-block">
            <b-row class="accordionForm mt-3 justify-content-end form-group p-0 pr-2 no-gutters">
              <!-- Bouton Retour -->
              <b-col cols="3">
                <b-button round class="button-action mx-2 mb-2" @click="$emit('close')">
                  {{ $t('common.bck') }}
                </b-button>
              </b-col>

              <!-- Bouton Sauvegarde -->
              <b-col cols="3">
                <b-button class="mx-2" variant="primary" @click="save">
                  <span>{{ $t('common.security.create_certificate') }}</span>
                </b-button>
              </b-col>
            </b-row>
          </div>

        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'

export default {
  name: 'CertificatePopUp',
  components: {
    'form-write-group-label-input': formWriteGroupLabelInput
  },
  props: ["form"],
  data: () => {
    return {
      dataNameId: {
        name: '',
        id: '',
      }
    }
  },
  created () {
    window.addEventListener('resize', this.changeMaxHeightClient)
    window.addEventListener('click', this.handleClick)
  },
  destroyed () {
    window.removeEventListener('resize', this.changeMaxHeightClient)
  },
  mounted () {
  },
  methods: {
    dontClose (e) {
      if (!e.target.closest('.modal-action')) {
        e.stopPropagation()
      }
    },
    handleClick (e) {
      if (e.target.closest('.modal-mask')) {
        this.$emit('close')
      }
    },
    save(){
      this.$emit('savepopup', this.dataNameId)
    }
  }
}
</script>
